module.exports = __webpack_public_path__ + "static/img/200046.ce3376e1.png";